import { observer } from "mobx-react-lite";

import { useCountries } from "../../catalogs/countries";
import { Select } from "../../components/ui-kit/fields/select";

export const RegionSelect = observer(function RegionSelect({
  country,
  ...restProps
}: {
  country?: string;
  model?: Record<string, any>;
  attr?: string;
  value?: number;
  onChange?: (newValue: number) => void;
  required?: boolean;
}) {
  const countries = useCountries();
  return (
    <Select<Record<string, any>, number>
      {...restProps}
      values={country ? countries.getRegionsEnum(country) : {}}
    />
  );
});
